module.exports = __webpack_public_path__ + "img/ai-img-acode.c77a8f67.png";